<div id="container-onboarding-wrapper">
  <div class="container-left">
    <div class="background-image">
    </div>
  </div>
  <div class="container-right">

    <div class="onboarding-header">
      <img ngSrc="/assets/images/coucou_visio_logo.png" alt="Logo" class="cursor-pointer" height="48" width="108" priority="high"
           (click)="navigateToHome()">
      <button mat-stroked-button (click)="navigateToHome()"
              class="base"
              type="button">
        Quitter
      </button>
    </div>

    <div class="container-onboarding-pages">
      <div>
        <router-outlet></router-outlet>
      </div>
    </div>

  </div>
</div>
